import LecomRefluxEvents from '../../reflux/events/lecom_reflux_events';

export default Object.assign({}, LecomRefluxEvents, {
	MESSAGE_ADDED: "MESSAGE_ADDED",
	MESSAGE_REMOVED: "MESSAGE_REMOVED"
});
